import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/hosting/domains")({
  component: () => <Outlet />,
});
